export default {
  name: 'Decisions',
  props: {
    data: {
      type: Array,
      default: null
    },
    data_full: { // decision with childs
      type: Array,
      default: null
    }
  },
  computed: {
    btnText () {
      return this.$t('applications.advance-expense.' + (this.show ? 'hide' : 'view') + '-decisions-history');
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    viewComments () {
      this.show = !this.show;
    }
  }
}
